import { useAuth } from '@/auth/useAuth';
import { useReadOnly } from '@/auth/useViewingAs';
import { STATUS_LABELS, isWritable } from '@/lib/organization';

/**
 * Whether the person may change the documents (P15), for the library and the
 * Categories page alike: not while staff are viewing, and not while the
 * organization's status forbids writes - which the page also says, in the
 * words `statusWord` gives. Read the way the Users page and the ARC builder
 * read it.
 */
export function useDocumentsWritable(): {
  writable: boolean;
  statusForbids: boolean;
  statusWord: string;
} {
  const { user } = useAuth();
  const organization = user?.organizations.find((o) => o.id === user.organizationId);
  const viewing = useReadOnly();
  const statusForbids = !isWritable(organization?.status);
  return {
    writable: !statusForbids && !viewing,
    statusForbids,
    statusWord: (STATUS_LABELS[organization?.status ?? ''] ?? 'not active').toLowerCase(),
  };
}
